import { useEffect, useState } from 'react';
import TopBar from '../../../hooks/TopBar';
import AvailabilitySelector from '../availability/Components';
import Preference from '../preference/Components';
import { fetchRatings, fetchScoreBoard, readUserApi } from './Api';
import PSecurityQuestionModal from './SecurityQuestionModal';
import UsrProfileSection from './UserProfileSection';
import WebRateModal from './WebsiteRateModal';
import DeleteAccountButton from './buttons/DeleteBtn';
import LogoutButton from './buttons/LogoutBtn';
import MatchHistoryModal from './modals/MatchHistoryModal';
// import SubscribeModal from './modals/SubscribeModal';




const UsrProfileLayout = () => {
  const [showRateModal, setShowRateModal] = useState(false);
  const [avgRating, setAvgRating] = useState(0);
  const [ratingLoaded, setRatingLoaded] = useState(false);
  const [scoreboard, setScoreboard] = useState([]);
  const [showMatchHistoryModal, setShowMatchHistoryModal] = useState(false);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [location, setLocation] = useState('');
const [user, setUser] = useState(null);


useEffect(() => {
  readUserApi()
    .then(data => setUser(data))
    .catch(err => console.error(err));
}, []);


  useEffect(() => {
    fetchRatings()
      .then(data => {
        setAvgRating(data.avg_rating || 0);
        setRatingLoaded(true);
      })
      .catch(err => {
        console.error('Failed to fetch rating:', err);
        setRatingLoaded(true);
      });

    fetchScoreBoard()
      .then(data => {
        setScoreboard(data.scoreboard || []);
        setLocation(data.current_location || ''); // set location here

      })
      .catch(err => {
        console.error('Failed to fetch scoreboard:', err);
      });
  }, []);

  return (
    <div
      style={{
        backgroundColor: '#ff9b45',
        minHeight: '100vh',

      }}
    >
      <TopBar />

      <div className="container-fluid p-3" sty
      le={{
        
      }}>

        <div className="row align-items-stretch">
          {/* Profile Section */}
          <div className="col-12 col-md-4 mb-3 mb-md-0">
            <div className="card shadow-sm h-100" style={{
              height: '100%',
              border: "10px solid transparent",
              borderRadius: "15px",
              background: "linear-gradient(white, white) padding-box, linear-gradient(315deg, #E51110 19%, #F08400 50%, #FFF049 76%) border-box",
              
       //       color: '#fff', // corrected

            }}>
              <div className="card-body" 
              style={{ 
                padding: '1rem', 
                fontSize: '0.9rem',
                backgroundColor: '#FFFAF0',
                color: '#740A03',}}>
                <UsrProfileSection />
              </div>
            </div>
          </div>


          {/* Main Content Section */}
          <div className="col-12 col-md-8">
            <div className="card shadow-sm" style={{
              height: '100%',        // fixed card height
              overflowY: 'auto',      // scroll inside if content overflows
              color: '#740A03',
              border: "10px solid transparent",
              borderRadius: "15px",
              background: "linear-gradient(white, white) padding-box, linear-gradient(315deg, #E51110 19%, #F08400 50%, #FFF049 76%) border-box",
       //       backgroundColor: '#ff9b45',
       //       color: '#fff', // corrected

            }}>
              <div className="card-body" style={{
                padding: '1rem',
                fontSize: '0.9rem',
                backgroundColor: '#FFFAF0',
              }}>

                {/* Preference & Availability */}
                <div className="row mb-3">
                  <h1
                  style={{
                    fontSize: '50px',
                    fontWeight: '700',
                    fontStyle: 'bold',
                    color: '#740A03',
                    fontFamily: 'Arial, sans-serif',
                    textTransform: 'uppercase',
                  }}
                  >Preference</h1>
                  <div className="col-12 col-md-6 mb-2"
                  style={{
                    fontSize: '20px',
                    fontWeight: '700',
                    fontStyle: 'bolder',
                    color: '#740A03',
                    fontFamily: 'Arial, sans-serif',
                    textTransform: 'uppercase',
                  }}>
                    <Preference />
                  </div>
                  <div className="col-12 col-md-6 mb-2">
                    <AvailabilitySelector />
                  </div>
                </div>

                {/* Scoreboard Card */}
                <div className="card mb-3 shadow-sm">
                  <div className="card-body">
                    <h2 className="card-title"
                      style={{
                        fontSize: '30px',
                        fontWeight: '700',
                        fontStyle: 'bolder',
                        color: '#740A03',
                        fontFamily: 'Arial, sans-serif'
                      }}
                    >
                      Scoreboard {location ? `| ${location}` : ''}
                    </h2>

                    <div
                      style={{
                        height: '340px',          // fixed height for scrollable content
                        overflowY: 'auto',
                        msOverflowStyle: 'none',  // IE/Edge
                        scrollbarWidth: 'none',    // Firefox
                      }}
                    >
                      <table className="table table-bordered mt-3">
                        <thead className="table-light">
                          <tr>
                            <th style={{ position: 'sticky', top: 0, background: '#f8f9fa', zIndex: 2 }}>Sports</th>
                            <th style={{ position: 'sticky', top: 0, background: '#f8f9fa', zIndex: 2 }}>Score</th>
                            <th style={{ position: 'sticky', top: 0, background: '#f8f9fa', zIndex: 2 }}>Tier</th>
                          </tr>
                        </thead>
                        <tbody>
                          {scoreboard.length === 0 ? (
                            <tr>
                              <td colSpan="3" className="text-center">No data available</td>
                            </tr>
                          ) : (
                            scoreboard.map((entry, index) => (
                              <tr key={index}>
                                <td>{entry.sport_name}</td>
                                <td>{entry.score ?? '-'}</td>
                                <td>{entry.tier_name ?? '-'}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>




                {/* Actions Card */}
                <div className="card mb-3 shadow-sm">
                  <div className="card-body d-flex flex-column flex-md-row justify-content-between align-items-center flex-wrap gap-3">
                    
                    <button className="btn btn-primary" onClick={() => setShowMatchHistoryModal(true)}>
                      Match History
                    </button>
{user && (
<button hidden></button>

)}

{/** 
  <button
  className="btn btn-success"
  style={{ display: user?.is_subscribed ? 'none' : 'inline-block' }}
  onClick={() => setShowSubscribeModal(true)}
>
  Subscribe to unlock rank mode
</button>
*/}


                    {/* Rating */}
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '1.5rem', lineHeight: '1' }}>
                      <span style={{ marginRight: '8px' }}>Ratings</span>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {[...Array(5)].map((_, i) => {
                          const fill = Math.min(Math.max(avgRating - i, 0), 1);
                          return (
                            <span
                              key={i}
                              style={{
                                position: 'relative',
                                display: 'inline-block',
                                width: '1.5rem',
                                height: '1.5rem',
                                marginRight: '2px',
                                fontSize: '1.5rem',
                                lineHeight: '1.5rem',
                                textAlign: 'center',
                              }}
                            >
                              <span
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  width: `${fill * 100}%`,
                                  overflow: 'hidden',
                                  color: '#ffc107',
                                  height: '100%',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                ★
                              </span>
                              <span style={{ color: '#ccc' }}>★</span>
                            </span>
                          );
                        })}
                      </div>
                      <span style={{ marginLeft: '8px', fontSize: '1.2rem', color: '#555' }}>
                        {ratingLoaded ? avgRating.toFixed(2) : '...'}
                      </span>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex flex-wrap gap-2 justify-content-end">
                      <PSecurityQuestionModal />
                      <button className="btn btn-outline-warning" onClick={() => setShowRateModal(true)}>
                        Rate Website
                      </button>
                      <DeleteAccountButton className="btn btn-outline-danger" />
                      <LogoutButton className="btn btn-outline-dark" />
                    </div>
                  </div>
                </div>



              </div>


            </div>
          </div>


        </div>
      </div>

      {/* Modals */}
      <WebRateModal
        show={showRateModal}
        onHide={() => setShowRateModal(false)}
        onSubmit={() => setShowRateModal(false)}
      />
      <MatchHistoryModal
        show={showMatchHistoryModal}
        onHide={() => setShowMatchHistoryModal(false)}
      />
{/* 
      <SubscribeModal
  show={showSubscribeModal}
  onHide={() => setShowSubscribeModal(false)}
/>
*/}
    </div>
  );
};

export default UsrProfileLayout;